import React from 'react';
import "../Sponsors/Sponsors.css";

export default function Sponsors() {
  const goldSponsors = [
    { name: "SMART EDGE ECE REVIEW SPECIALIST", logo: "pics/sponsors/smartedge.png" },
    { name: "SUMITOMO ELECTRIC INDUSTRIES", logo: "pics/sponsors/sei.png" },
    { name: "VYBE by BPI", logo: "pics/sponsors/bpi.png" },
  ];

  const row2Sponsors = [
    { name: "MICROCADD", logo: "pics/sponsors/microcadd.png" },
    { name: "SLIC3D", logo: "pics/sponsors/sliced.jpg" },
    { name: "SPLASH ISLAND", logo: "pics/sponsors/splash-island.png" },
    { name: "933 CREATIVES", logo: "pics/sponsors/933.jpg" },
  ];

  const row3Sponsors = [
    { name: "XINYX", logo: "pics/sponsors/xinyx.png" },    
    { name: "Jassen Harris Industries Corp.", logo: "pics/sponsors/jassen-harris.png" },
    { name: "SHAWARMA ALMALIK", logo: "pics/sponsors/shawarma.jpg" },
  ];

  const SponsorCard = ({ sponsor, size = "md" }) => (
    <div className={`sponsor-card sponsor-card--${size}`}>
      <div className="sponsor-card__box">
        <img src={sponsor.logo} alt={sponsor.name} />
      </div>
      <p className="sponsor-name">{sponsor.name}</p>
    </div>
  );

  return (
    <div className="sponsors-container">
      <h1 className="sponsors-title">SPONSORS</h1>
      <div className="sponsors-divider" />
      <section className="sponsors-section">
        {/* Row 1 — Gold Sponsors */}
        <div className="sponsors-row sponsors-tier-gold">
          {goldSponsors.map((s, i) => (
            <SponsorCard key={i} sponsor={s} size="lg" />
          ))}
        </div>

        {/* Row 2 — 4 sponsors */}
        <div className="sponsors-row sponsors-tier-silver">
          {row2Sponsors.map((s, i) => (
            <SponsorCard key={i} sponsor={s} size="md" />
          ))}
        </div>

        {/* Row 3 — 3 sponsors */}
        <div className="sponsors-row sponsors-tier-bronze">
          {row3Sponsors.map((s, i) => (
            <SponsorCard key={i} sponsor={s} size="sm" />
          ))}
        </div>
      </section>
    </div>
  );
}